module.exports = __webpack_public_path__ + "img/list_6.6c785360.jpg";